"use client";
import { jsxs as o, jsx as l } from "react/jsx-runtime";
import { memo as r } from "react";
import t from "../components/Icon/SvgIcon.js";
const d = (e) => /* @__PURE__ */ o(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...e,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7.147 5.966a7.75 7.75 0 1 0 12.59 6.62.625.625 0 1 1 1.247.094 9 9 0 1 1-3.591-7.893.625.625 0 0 1-.748 1.002 7.75 7.75 0 0 0-9.498.177",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m16.66 2.882-2.533 3.395a.5.5 0 0 0 .352.796l4.093.413a.5.5 0 0 0 .513-.687l-1.562-3.807a.5.5 0 0 0-.862-.11"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M14.428 7.57a1 1 0 0 1-.702-1.592l2.534-3.395a1 1 0 0 1 1.726.22l1.562 3.806a1 1 0 0 1-1.026 1.375zm.1-.995 4.094.414-1.561-3.807z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), f = r(d);
export {
  f as Refresh,
  f as default
};
